const MapIcon = ({
  size = 16,
  color = "#E7000B",
  strokeWidth = 1.333,
  isActive = false,
}) => {
  const activeColor = isActive ? "#dc2626" : color;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 13.3333L2.36867 11.5173C2.25795 11.462 2.16481 11.3769 2.0997 11.2717C2.03459 11.1664 2.00007 11.0451 2 10.9213V3.74533C2.00006 3.63174 2.02915 3.52004 2.0845 3.42085C2.13985 3.32165 2.21963 3.23824 2.31626 3.17853C2.4129 3.11883 2.52319 3.08481 2.63667 3.0797C2.75015 3.07458 2.86305 3.09855 2.96467 3.14933L6 4.66666M6 13.3333L10 11.3333M6 13.3333V4.66666M6 4.66666L10 2.66666M10 11.3333L13.0353 12.8507C13.1369 12.9014 13.2499 12.9254 13.3633 12.9203C13.4768 12.9152 13.5871 12.8812 13.6837 12.8215C13.7804 12.7618 13.8602 12.6783 13.9155 12.5792C13.9709 12.48 13.9999 12.3683 14 12.2547V5.07866C13.9999 4.95489 13.9654 4.83358 13.9003 4.72831C13.8352 4.62305 13.7421 4.53799 13.6313 4.48266L10 2.66666M10 11.3333V2.66666"
        stroke={activeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MapIcon;
